// we have simplified skinning formulas to just one option for now
export enum SkinningFormula {
  DistanceChildTargeting = 'distance-child-targeting'
}
